
import { z } from "zod";

export const RequestForQuoteStatusValues = ["ACCEPTED", "AWAITING_READY_TO_ACCEPT", "PENDING_REVIEW", "REJECTED"] as const;
export const RequestForQuoteStatusSchema = z.enum(RequestForQuoteStatusValues);
export const RequestForQuoteStatus = RequestForQuoteStatusSchema.enum;
export type RequestForQuoteStatus = (typeof RequestForQuoteStatusValues)[number];
export const RequestForQuoteStatusDisplayNames = { "ACCEPTED": "Accepted",
"AWAITING_READY_TO_ACCEPT": "Awaiting Ready to Accept",
"PENDING_REVIEW": "Pending Review",
"REJECTED": "Rejected", } satisfies Record<RequestForQuoteStatus, string>;
